import { Button } from '@mui/material';

import { useState, MouseEventHandler } from 'react';

import { AlertDialog } from '.';

type DialogButtonProps = {
  title: string;
  text: string;
  buttonText: string;
  buttonColor:
    | 'inherit'
    | 'success'
    | 'error'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'warning';
  okText: string;
  ngText: string;
  disabled?: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
};

function AlertDialogButton(props: DialogButtonProps) {
  const [open, setOpen] = useState(false);

  const handleOpen: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        color={props.buttonColor}
        onClick={handleOpen}
        disabled={props.disabled}
      >
        {props.buttonText}
      </Button>
      <AlertDialog open={open} onClose={handleClose} {...props} />
    </>
  );
}

export default AlertDialogButton;
